var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2448 0H2.68054C1.20195 0 0 1.20195 0 2.68054V14.0016C0 15.4802 1.20195 16.6821 2.68054 16.6821H19.2403C20.7189 16.6821 21.9209 15.4802 21.9209 14.0016V2.68499C21.9253 1.2064 20.7234 0 19.2448 0ZM20.7009 14.0016C20.7009 14.8043 20.0478 15.4574 19.2448 15.4574H2.68054C1.87785 15.4574 1.22475 14.8043 1.22475 14.0016V2.68499C1.22475 1.8823 1.87785 1.22892 2.68054 1.22892H19.2403C20.043 1.22892 20.6964 1.88202 20.6964 2.68499V14.0016H20.7009Z",
    fill: "url(#paint0_linear_88_134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8245 8.2004L19.1856 3.39261C19.435 3.16573 19.4578 2.78037 19.2309 2.52625C19.004 2.27685 18.6187 2.25405 18.3646 2.48093L10.9716 9.11681L9.52914 7.82867C9.52469 7.82422 9.51996 7.81949 9.51996 7.81504C9.48827 7.78335 9.45657 7.7561 9.42015 7.72885L3.55109 2.47648C3.29697 2.2496 2.91161 2.2724 2.68473 2.52625C2.45786 2.78037 2.48066 3.16573 2.7345 3.39261L8.15898 8.24127L2.7573 13.2985C2.51235 13.5298 2.49873 13.9154 2.73005 14.1648C2.85267 14.2919 3.01587 14.3597 3.17908 14.3597C3.32866 14.3597 3.47853 14.3052 3.59641 14.1965L9.08011 9.06676L10.5679 10.3958C10.6858 10.5 10.8309 10.5501 10.976 10.5501C11.1212 10.5501 11.2708 10.4956 11.3842 10.3913L12.9128 9.02144L18.3646 14.2012C18.4824 14.3147 18.6368 14.3692 18.7863 14.3692C18.9495 14.3692 19.1083 14.3058 19.2309 14.1787C19.4622 13.9338 19.4531 13.5437 19.2084 13.3124L13.8245 8.2004Z",
    fill: "url(#paint1_linear_88_134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_134",
    x1: 0,
    y1: 8.34107,
    x2: 21.9209,
    y2: 8.34107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19699D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2492A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_134",
    x1: 2.52832,
    y1: 8.34462,
    x2: 19.3983,
    y2: 8.34462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19699D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2492A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.184fff454685060844cd0f3405501164.svg";
export { ForwardRef as ReactComponent };